export default __webpack_public_path__ + "static/media/register.78e125f4.jpg";